module.exports = __webpack_public_path__ + "img/var_bool.99665a6.svg";